import { Flex, Form, Modal, Typography } from "antd";
import { styled } from "styled-components";

const { Text } = Typography;

export const StyledForgotPasswordModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    padding: 16px;
  }
  svg {
    cursor: pointer;
  }
`;

export const StyledForgotPasswordForm = styled(Form)`
  width: 100%;
  .ant-form-item {
    margin-bottom: 16px;
  }
  .ant-input,
  .ant-input-affix-wrapper {
    padding: 16px;
  }
`;

export const StyledForgotPasswordCard = styled(Flex)`
  height: 100%;
  width: -webkit-fill-available;
  background-color: ${({ theme }) => theme.palette.background.paper};
  padding: 16px;
  border-radius: 8px;
`;

export const StyledForgotPasswordSubtitle = styled(Text)`
  text-align: center;
`;
